import ClientRoutes from "./Routes";

const UNAUTH_DEFAULT_STORAGE_KEY = "defaultUnAuthRoute";
/** ברירת מחדל למשתמשים ללא ערך ב-localStorage (למשל מחוברים מלפני העדכון) */
const DEFAULT_UNAUTH_ROUTE = "main";
const VALID_UNAUTH_ROUTES = [
  "main",
  "mainSBS",
  "mainDIY",
  "mainCG",
  "mainTI",
  "mainWD",
  "mainDubi",
  "mainTipTop",
];

/**
 * מחזיר את נתיב ההתחברות להפניה (לפי localStorage או main).
 * בשימוש ב-DefaultRedirect וב-LogoutSpecipic כדי שההפניה תעבוד גם ב-PWA.
 */
export const getUnAuthRedirectPath = () => {
  const savedRoute = localStorage.getItem(UNAUTH_DEFAULT_STORAGE_KEY);
  return savedRoute &&
    VALID_UNAUTH_ROUTES.includes(savedRoute) &&
    ClientRoutes.UnAuth[savedRoute]
    ? ClientRoutes.UnAuth[savedRoute]
    : ClientRoutes.UnAuth[DEFAULT_UNAUTH_ROUTE];
};
